var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('action')}}},[_c('v-icon',_vm._g({class:_vm.iconClass,attrs:{"small":"","color":_vm.iconColor}},on),[_vm._v("\n\t\t\t\t"+_vm._s(_vm.icon)+"\n\t\t\t")])],1)]}}])},[_vm._v("\n\t"+_vm._s(_vm.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }